import angular from 'angular'
import template from './template.html'

angular.module('nominas.catalogos')
  .component('nominasCatalogosConceptos', {
    template: template,
    controller: NominasCatalogosConceptosComponent,
  });

function NominasCatalogosConceptosComponent($filter, $http) {
  let $ctrl = this,
    filterBy = $filter('filter'),
    groupBy = $filter('groupBy'),
    orderBy = $filter('orderBy');

  $ctrl.$onInit = $onInit;
  $ctrl.actualizar = actualizar;
  $ctrl.filtrar = filtrar;
  $ctrl.filtro = '';
  $ctrl.id = null;
  $ctrl.resultados = [];

  function $onInit() {
    $ctrl.promise = $http.get('api/nominas/catalogos/conceptos')
      .then(function (response) {
        $ctrl.data = orderBy(response.data, 'descripcion');

        filtrar();
      });
  }

  function actualizar(item, data) {
    if (data) {
      angular.extend(item, data);
    }

    $ctrl.id = null;
  }

  function filtrar() {
    $ctrl.resultados = groupBy(filterBy($ctrl.data, $ctrl.filtro), 'naturaleza');
  }
}



// WEBPACK FOOTER //
// ./src/nominas/catalogos/components/conceptos/controller.js